import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import ClickOutside from 'Component/ClickOutside';

export class FieldSuggestionsComponent extends PureComponent {
    renderOption(option) {
        const {
            id,
            label,
            isAvailable = true
        } = option;

        const {
            isExpanded,
            handleSelectListOptionClick
        } = this.props;

        return (
            <li
              block="FieldSelect"
              elem="Option"
              mods={ {
                  isDisabled: !isAvailable,
                  isExpanded,
              } }
              key={ id }
              /**
               * Added 'o' as querySelector does not work with
               * ids, that consist of numbers only
               */
              id={ `o${id}` }
              role="menuitem"
              // eslint-disable-next-line react/jsx-no-bind
              onMouseDown={ () => handleSelectListOptionClick(option) }
              // eslint-disable-next-line react/jsx-no-bind
              onTouchStart={ () => handleSelectListOptionClick(option) }
              // eslint-disable-next-line react/jsx-no-bind
              onKeyPress={ () => handleSelectListOptionClick(option) }
              tabIndex={ isExpanded ? '0' : '-1' }
            >
                { label }
            </li>
        );
    }

    renderOptions() {
        const {
            suggestions,
            isExpanded,
            isDropdownOpenUpwards,
            isScrollable,
            isSuggestionsEnabled
        } = this.props;

        if (!isSuggestionsEnabled) {
            return null;
        }

        return (
            <ul
              block="FieldSelect"
              elem="Options"
              role="menu"
              mods={ {
                  isExpanded,
                  isDropdownOpenUpwards,
                  isNotScrollable: !isScrollable
              } }
            >
                <div
                  block="FieldSelect"
                  elem="OptionsWrapper"
                  role="menu"
                  mods={ { isExpanded } }
                >
                    { suggestions.map(this.renderOption.bind(this)) }
                </div>
            </ul>
        );
    }

    render() {
        const {
            attr: { id = '' } = {},
            setRef,
            attr,
            events,
            isDisabled,
            isExpanded,
            handleDropdownExpand,
            handleSelectListKeyPress,
        } = this.props;

        return (
            <ClickOutside onClick={ handleDropdownExpand }>
                <div
                  id={ `${ id }_wrapper` }
                  block="FieldSuggestions"
                  mods={ { isExpanded } }
                  //   onClick={ !isDisabled && handleSelectExpand }
                //   onKeyPress={ !isDisabled && handleSelectListKeyPress }
                  role="button"
                  tabIndex="0"
                  aria-label="Select dropdown"
                  aria-expanded={ isExpanded }
                >
                    <div 
                      block="FieldSuggestions"
                      elem="Wrapper"
                    >
                        <input
                          ref={ (elem) => setRef(elem) }
                          disabled={ isDisabled }
                          type="text"
                          { ...attr }
                          { ...events }
                          autocomplete="no_show"
                        />
                    </div>
                    { this.renderOptions() }
                </div>
            </ClickOutside>
        );
    }
}

export default FieldSuggestionsComponent;